import type { OrderDetailsExtended } from 'app/src/model'
import { apiBaseUrl } from 'app/src/msw/shopping/staticapi/apiBaseUrl'
import type { shoppingApi } from 'app/src/services/welfareportal'
import { http, HttpResponse } from 'msw'

export const getOrder = http.get<{ orderId: string }, object, shoppingApi.OrderDetails>(
  apiBaseUrl + '/orders/:orderId',
  async ({ params }) => {
    const orderId = params.orderId
    const discountOrders = await (await fetch('./data/shopping/discountOrders.json')).json()
    const giftCardsOrders = await (await fetch('./data/shopping/giftCardsOrders.json')).json()
    const goodAndServiceOrders = await (await fetch('./data/shopping/goodAndServiceOrders.json')).json()
    const vouchersOrders = await (await fetch('./data/shopping/vouchersOrders.json')).json()

    const orders: OrderDetailsExtended[] = [
      ...(discountOrders?.items || []),
      ...(giftCardsOrders?.items || []),
      ...(goodAndServiceOrders?.items || []),
      ...(vouchersOrders?.items || []),
    ]

    const order = orders.find((order) => order.orderId === orderId)

    if (!order && orderId === 'failed') {
      return new HttpResponse('Order not found', {
        status: 404,
        headers: {
          'Content-Type': 'application/json',
        },
      })
    } else if (!order && orderId === 'discount') {
      const newOrder: OrderDetailsExtended = discountOrders?.items[0]
      newOrder.status = 'draft'
      return HttpResponse.json(newOrder)
    } else if (!order && orderId === 'giftCard') {
      const newOrder: OrderDetailsExtended = giftCardsOrders?.items[0]
      newOrder.status = 'draft'
      return HttpResponse.json(newOrder)
    } else if (!order && orderId === 'voucher') {
      const newOrder: OrderDetailsExtended = vouchersOrders?.items[0]
      newOrder.status = 'draft'
      return HttpResponse.json(newOrder)
    } else if (!order && orderId === 'goodAndService') {
      const newOrder: OrderDetailsExtended = goodAndServiceOrders?.items[0]
      newOrder.status = 'draft'
      return HttpResponse.json(newOrder)
    }

    return HttpResponse.json(order)
  },
)
